import React from 'react';
import { t } from '../i18n';

const ChartCard = ({
  title = '',
  children = null,
  className = '',
  actions = null
}) => {
  return (
    <div className={`bg-white rounded border border-neutral-200 p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-neutral-800">{t(title)}</h3>
        {actions && (
          <div className="flex gap-2">
            {t(actions)}
          </div>
        )}
      </div>

      <div className="h-72">
        {children}
      </div>
    </div>
  );
};

export default ChartCard;